import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap, map } from 'rxjs';
import { CommonIdFindUniversitiesService } from 'src/app/services/common-id/common-id-find-universities.service';

import * as CommonIdFindUniversitiesActions from '../../actions/common-id/common-id-find-universities.actions';
import { FirebaseCallableFunctionError } from '../../errors/firebase-callable-function-error';

@Injectable()
export class CommonIdFindUniversitiesEffects {
  private LOG_SOURCE = this.constructor.name;

  /* 登録されている志望校の大学情報取得 */
  commonIdFindUniversities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommonIdFindUniversitiesActions.commonIdFindUniversities),
      switchMap(action =>
        this.commonIdFindUniversitiesService.commonIdFindUniversities(action.request).pipe(
          map(response => CommonIdFindUniversitiesActions.commonIdFindUniversitiesSuccess({ response })),
          catchError(e =>
            of(CommonIdFindUniversitiesActions.commonIdFindUniversitiesFailure({ error: FirebaseCallableFunctionError.from(e) }))
          )
        )
      )
    )
  );

  constructor(private actions$: Actions, private commonIdFindUniversitiesService: CommonIdFindUniversitiesService) {}
}
